<template>
  <div class="content-layout">
    <HeaderComponent />
    <router-view />
  </div>
  <FooterComponent class="footer-layout" />
</template>
<script>
import HeaderComponent from "@/components/HeaderComponent";
import FooterComponent from "@/components/FooterComponent";

export default {
  name: "OnlineLayout",
  components: {HeaderComponent, FooterComponent},
};
</script>

<style lang="scss" scoped>

.content-layout {
  min-height: 94vh;
  padding: 0;
  margin: 0;
}

.footer-layout {
  min-height: 6vh;
  padding: 0;
  margin: 0;
}
</style>
